import { defineMessage } from 'react-intl'
import iconBus from 'assets/icons/bus_blue.svg'
import iconBusSeat from 'assets/icons/busSeat.svg'
import iconMap from 'assets/icons/map_blue.svg'

export const infoIconsData = [
    {
        icon: iconBusSeat,
        iconAlt: 'Bus seat icon',
        text: defineMessage({
            id: 'upsells.transport.seating_advantage',
            defaultMessage: '_',
        }),
    },
    {
        icon: iconBus,
        iconAlt: 'Bus icon',
        text: defineMessage({
            id: 'upsells.transport.coaches_advantage',
            defaultMessage: '_',
        }),
    },
    {
        icon: iconMap,
        iconAlt: 'Map icon',
        text: defineMessage({
            id: 'upsells.transport.routes_advantage',
            defaultMessage: '_',
        }),
    },
]

export const guidelinesData = [
    defineMessage({
        id: 'upsells.transport.modal_guidelines_ticket',
        defaultMessage: '_',
    }),
    defineMessage({
        id: 'upsells.transport.modal_guidelines_punctuality',
        defaultMessage: '_',
    }),
    defineMessage({
        id: 'upsells.transport.modal_guidelines_stops',
        defaultMessage: '_',
    }),
    defineMessage({
        id: 'upsells.transport.modal_guidelines_no_cash',
        defaultMessage: '_',
    }),
]
